"use client";

import React from "react";
import { Instagram, Twitter, Facebook, ArrowUp, Loader, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted) {
    return <div data-section-id="2902" className="p-4 bg-white/5 border border-white/10 rounded-md text-secondary text-sm animate-in fade-in slide-in-from-bottom-2">
        <p className="font-medium">Welcome to the Trade Corridor.</p>
        <p className="text-xs opacity-80 mt-1">Check your inbox for trade insights and updates.</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-2">
      <div className="flex w-full items-start gap-2">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1 space-y-0">
              <FormControl>
                <Input placeholder="BUSINESS EMAIL ADDRESS" className="bg-white/5 border-white/20 focus:border-secondary focus:ring-secondary/20 h-10 text-xs tracking-wider uppercase placeholder:text-primary-foreground/40 transition-all" {...field} />
              </FormControl>
              <FormMessage className="text-[10px] mt-1 absolute text-secondary" />
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} className="h-10 px-6 bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground font-bold tracking-widest text-xs transition-all duration-300 focus:animate-pulse focus:ring-2 focus:ring-secondary focus:ring-offset-2 focus:ring-offset-primary">
          {isSubmitting ? <Loader className="size-3 animate-spin" /> : "SUBSCRIBE"}
        </Button>
      </div>
      <p className="text-[10px] text-primary-foreground/50 pt-2">
        By subscribing, you agree to our Terms of Service and Privacy Policy.
      </p>
    </Form>;
}
export default function SiteFooter() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="bg-primary text-primary-foreground border-t border-white/10 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/50 to-transparent opacity-50" />
      
      <div className="container mx-auto px-6 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              <img src="/img/threadpulse_logo_white.png" alt="EuroIndiaTrade" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-primary-foreground/70 text-[13px] leading-relaxed max-w-xs font-sans">
              EuroIndiaTrade.com is the premier B2B digital bridge connecting European and Indian markets, facilitating seamless trade, logistics, and market-entry services across the economic corridor.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-serif font-semibold tracking-widest uppercase text-primary-foreground">Trade Resources</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/TradeServicesPage" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                Verified Suppliers
              </Link>
              <Link to="/TradeServicesPage" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                Logistics Partners
              </Link>
              <Link to="/RegulatoryPage" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                Market Regulations
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                Trade Data & Insights
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-serif font-semibold tracking-widest uppercase text-primary-foreground">Company</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/MarketEntryPage" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit flex items-center gap-2 group font-sans">
                <span>Market Entry</span>
                <span className="w-1.5 h-1.5 rounded-lg bg-secondary animate-pulse group-hover:bg-accent" />
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                Success Stories
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans">
                About Our Mission
              </Link>
              <Link to="mailto:shivansh.paliwal@euroindiatrade.com" className="text-primary-foreground/70 hover:text-secondary transition-colors text-[13px] w-fit font-sans flex items-center gap-2">
                <Mail className="size-3.5" />
                shivansh.paliwal@euroindiatrade.com
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-serif font-semibold tracking-widest uppercase text-primary-foreground flex items-center gap-2">
              <Mail className="size-4 text-secondary" />
              Market Intelligence
            </h3>
            <p className="text-primary-foreground/70 text-[13px] font-sans">
              Subscribe to receive quarterly trade reports, regulatory updates, and exclusive B2B networking opportunities.
            </p>
            
            <FormProvider formId="newsletter-footer" sectionName="site-footer" defaultValues={{
            email: ""
          }} className="w-full">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          
          {}
          <div className="flex items-center gap-4">
            <Link to="https://instagram.com" newTab className="text-primary-foreground/60 hover:text-secondary transition-colors p-2 hover:bg-white/5 rounded-lg">
              <Instagram className="size-5" />
              <span className="sr-only">Instagram</span>
            </Link>
            <Link to="https://tiktok.com" newTab className="text-primary-foreground/60 hover:text-secondary transition-colors p-2 hover:bg-white/5 rounded-lg">
              {}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-5">
                <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
              </svg>
              <span className="sr-only">LinkedIn</span>
            </Link>
            <Link to="https://twitter.com" newTab className="text-primary-foreground/60 hover:text-secondary transition-colors p-2 hover:bg-white/5 rounded-lg">
              <Twitter className="size-5" />
              <span className="sr-only">X (Twitter)</span>
            </Link>
          </div>

          {}
          <div className="text-[11px] text-primary-foreground/50 text-center md:text-left font-sans tracking-wide">
            &copy; {currentYear} EuroIndiaTrade.com. All rights reserved. Precision in Global Trade.
          </div>

          {}
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="group text-[11px] font-bold text-primary-foreground/70 hover:text-secondary hover:bg-transparent p-0 h-auto gap-2 tracking-widest">
            BACK TO TOP
            <div className="p-2 rounded-lg border border-white/10 group-hover:border-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-all duration-300">
              <ArrowUp className="size-4" />
            </div>
          </Button>
        </div>
      </div>
    </footer>;
}